import { IFormField } from '../IForm.types';

export class ItemForm {
  key: string;
  input = true;
  labelPosition = 'top';
  label: string;
  hideLabel = false;
  dataGridLabel = false;
  customClass = 'mb-4';
  description = '';
  validate: any = {
    required: false,
    customMessage: 'Questo campo è obbligatorio',
  };
  defaultValue: string;
  tooltip:string;
  constructor(field: IFormField) {
    this.key = field.key;
    this.validate.required = `${field.isOptional}`.toLowerCase() !== 'true' ;
    this.label = field.description;
    this.defaultValue = field.defaultValue;
    this.tooltip = field.tooltip
  }
}
